<template>
  <div class="profile">
    <a-card title="个人资料">
      <div class="content-wrapper">
        <a-form style="width: 400px" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-form-item label="昵称">
            <a-input v-model="userInfo.nickname"></a-input>
          </a-form-item>
          <a-form-item label="邮箱">
            <a-input :disabled='true' :value="userInfo.email"></a-input>
          </a-form-item>
          <a-form-item label="手机">
            <a-input v-model="userInfo.phone"></a-input>
          </a-form-item>
          <a-form-item label="用户类型">
            <a-tag color="#f50"><a-icon type="crown" style="margin-right: 5px" />Member</a-tag>
          </a-form-item>
          <a-form-item label="配额">
            ∞
          </a-form-item>
        </a-form>
        <div class="avatar-wrapper">
          <a-avatar :size="128" v-if="userInfo.avatar" :src="userInfo.avatar" />
          <a-avatar :size="128" v-else icon='user' />
          <a-button disabled>上传头像</a-button>
        </div>
      </div>
      <a-button :loading="requesting" type="primary" @click="handleUpdate">{{requesting ? '保存中' : '保存更改'}}</a-button>
    </a-card>
    <a-card title="安全设置" style="margin-top: 20px">
      <a-form ref="passwordForm" :form="passwordForm" style="width: 400px" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
        <a-form-item label="原密码">
          <a-input type="password"
          v-decorator="[
            'oldPassword',
            {rules: [{ required: true, message: '原密码不能为空' }]}
          ]"></a-input>
        </a-form-item>
        <a-form-item label="新密码">
          <a-input type="password"
          v-decorator="[
            'newPassword',
            {rules: [
              { required: true, message: '新密码不能为空' },
              { min: 6, max: 32, message: '新密码长度需在 6-32 之间' }
            ]}
          ]"></a-input>
        </a-form-item>
        <a-form-item label="重复新密码">
          <a-input type="password" v-decorator="[
            'newPasswordConfirm',
            {rules: [
              { required: true, message: '新密码确认不能为空' },
              { validator: validatePasswordConfirm }
            ]}
          ]"></a-input>
        </a-form-item>
      </a-form>
      <a-button type='primary' @click="handleUpdatePassword" :loading='updatingPassword'>修改密码</a-button>
    </a-card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { updateUserInfo, updatePassword } from '@/api/user'
import { message } from 'ant-design-vue'
export default {
  data() {
    return {
      requesting: false,
      updatingPassword: false,
      passwordForm: this.$form.createForm(this)
    }
  },
  computed: {
    ...mapState('UserModule', ['userInfo'])
  },
  methods: {
    ...mapActions('UserModule', ['GET_USERINFO']),
    async handleUpdate() {
      this.requesting = true
      const { nickname, phone } = this.userInfo
      try {
        await updateUserInfo({ nickname, phone: phone || undefined })
        message.success('保存成功')
      } finally {
        this.requesting = false
      }
      this.GET_USERINFO()
    },
    async handleUpdatePassword() {
      try {
        const res = await this.passwordForm.validateFields({ force: true })
      } catch(e) {
        return
      }
      const { oldPassword, newPassword } = this.passwordForm.getFieldsValue()
      this.updatingPassword = true
      try{
        await updatePassword(oldPassword, newPassword)
        message.success('密码修改成功')
        this.passwordForm.resetFields()
      } catch(e) {
        message.error(e.response.data.message)
      } finally {
        this.updatingPassword = false
      }
    },
    validatePasswordConfirm(rule, value, callback){
      // any error inside this function will be swallowed ...
      const newPasswordConfirm = this.passwordForm.getFieldValue('newPassword')
      if (newPasswordConfirm !== value) callback('两次输入密码不一致')
      else callback()
    }
  }
}
</script>

<style scoped lang='scss'>
.content-wrapper {
  display: flex;
}
.avatar-wrapper {
  margin-left: 50px;
  display: flex;
  flex-direction: column;
  & > * + * {
    margin-top: 10px;
  }
}
</style>